@use '@fukuri-admins/ui/layout' as *;

.select {
  :global(.single-select__control) {
    border-radius: borderRadius('md');
    border: 1px solid border('Quaternary');

    &:hover {
      border-color: border('Quaternary');
    }
  }

  :global(.single-select__value-container ) {
    padding: spacing('8') spacing('12');
  }

  :global(.single-select__placeholder) {
    @include typography('Jp/14_W3');
    color: text('Placeholder');
    margin: 0;
  }

  :global(.single-select__input-container) {
    padding: 0;
    margin: 0;
  }

  :global(.single-select__single-value) {
    @include typography('Jp/14_W3');
    color: text('High');
  }

  :global(.single-select__control--is-focused) {
    box-shadow: 0 0 0 3px border('Focus');
  }
  
  :global(.single-select__indicators) {
    padding: spacing('8') spacing('12');
  }

  :global(.single-select__indicator) {
    padding: 0;
    > svg {
      color: text('High');
      width: 16px;
      height: 16px;
      opacity: 0.5;
    }
  }
}

.loadMoreButton {
  padding: 10px;
  text-align: center;
  cursor: pointer;
}
